import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./mobileLogin.css";
import api from "../../../api";

export const MobileLogin = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const salesPersonId = localStorage.getItem("salesPersonId");

    if (salesPersonId) {
      navigate("/mobile", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async () => {
    if (!username.trim() || !password.trim()) {
      setError("Please enter both username and password.");
      setTimeout(() => setError(""), 3000);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await api.post("/api/login", {
        username,
        password,
      });

      if (res.data?.errCode == -3) {
        setError(res.data?.errMsg || "Invalid username or password.");
        setTimeout(() => setError(""), 4000);
        return;
      }

      const salesPersonId = res.data?.data?.SalesPersonId;

      localStorage.setItem(
        "salesPersonId",
        salesPersonId !== null && salesPersonId !== undefined
          ? String(salesPersonId)
          : ""
      );

      navigate("/mobile");
    } catch (e) {
      setError(
        e.response?.data?.message || "Invalid username or password."
      );
      setTimeout(() => setError(""), 4000);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <div className="mobileLoginMain">
      <div className="mobileLoginHeader">
        <div className="mobileLoginLogoBox">
          <span className="material-symbols-outlined">pie_chart</span>
        </div>
        <p className="mobileLoginAppName">Alpap CRM</p>
      </div>

      <div className="mobileLoginBody">
        <div className="mobileLoginCard">
          <div className="mobileLoginSecurePill">
            <span className="material-symbols-outlined mobileLoginSecureIcon">
              security
            </span>
            <span className="mobileLoginSecureText">Secure access</span>
          </div>

          <div className="mobileLoginTitleGroup">
            <p className="mobileLoginTitle">Sign in to Alpap CRM</p>
            <p className="mobileLoginSubtitle">
              Use your username and password to access your dashboard.
            </p>
          </div>

          <div className="mobileLoginFieldGroup">
            <p className="mobileLoginFieldLabel">Username</p>
            <div className="mobileLoginInputWrapper">
              <input
                className="mobileLoginInput"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={handleKeyDown}
                autoComplete="username"
              />
              <span className="material-symbols-outlined mobileLoginInputIcon">
                person
              </span>
            </div>
          </div>

          <div className="mobileLoginFieldGroup">
            <p className="mobileLoginFieldLabel">Password</p>
            <div className="mobileLoginInputWrapper">
              <input
                className="mobileLoginInput"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
                autoComplete="current-password"
              />
              <span
                className="material-symbols-outlined mobileLoginInputIcon mobileLoginPasswordToggle"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? "visibility_off" : "visibility"}
              </span>
            </div>
          </div>

          {error && <p className="mobileLoginError">{error}</p>}

          <button
            className="mobileLoginSubmitBtn"
            onClick={handleSubmit}
            disabled={loading}
          >
            <span className="material-symbols-outlined mobileLoginSubmitIcon">
              login
            </span>
            {loading ? "Signing in..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};